// extracted by mini-css-extract-plugin
export default {"header":"ContentToggleSection_header__rGvUE"};